const debug = false;
function log(msg,type){
  if (!debug) return
  switch (type) {
    case "error":
      console.error(msg)
      break;
    case "warn":
      console.warn(msg)
      break;
    default:
      console.log(msg);
  }
}

window.__reisePendingCartAdded = window.__reisePendingCartAdded || null;
window.reiseOnCartAdded = function (item) {
  if (typeof window.__reiseHandleCartAdded === 'function') {
    window.__reiseHandleCartAdded(item || null);
  } else {
    window.__reisePendingCartAdded = item || null;
  }
};

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('button[copy-discount]').forEach(button => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.discount-code-copy');
      const code = wrapper.getAttribute('code');
  
      navigator.clipboard.writeText(code).then(() => {
        const originalText = button.textContent;
        button.textContent = 'copiado';
  
        setTimeout(() => {
          button.textContent = originalText;
        }, 5000);
      }).catch(err => {
        log(`Erro ao copiar: ${err}`,'error')
      });
    });
  });
  
  // Seleciona o elemento do formulário
  var formElement = document.querySelector('.product-form.check-selected-variant form');
  
  // Verifica se o elemento existe antes de adicionar o ouvinte de evento
  if (formElement) {
      formElement.addEventListener('submit', function(event) {
          // Previne o envio imediato do formulário
          event.preventDefault();
          // Flag para controlar se o formulário deve ser enviado
          let shouldSubmit = true;
  
          // Seleciona todos os inputs do formulário
          const inputs = document.querySelectorAll('.product-form__input');
  
          // Percorre cada input para verificar a presença da classe '.block-swatch'
          inputs.forEach(input => {
              if (input.classList.contains('block-swatch')) {
                  // Adiciona uma classe de erro se a classe '.block-swatch' for encontrada
                  input.classList.add('classe-erro');
                  shouldSubmit = false; // Marca o formulário para não ser enviado
              }
          });
  
          // Se nenhum elemento com '.block-swatch' foi encontrado, o formulário pode ser enviado
          if (shouldSubmit) {
              this.submit(); // Submete o formulário
          } else {
              // Aqui você pode adicionar qualquer lógica adicional para quando o formulário não puder ser enviado
            
              log('Um ou mais campos obrigatórios precisam ser selecionados.','log')
          }
      });
  } else {
      log('O formulário especificado não foi encontrado.','error')
  }
  
  $('.product-form__label').on('click', function(){
    $(this).closest('.product-form__input').removeClass('block-swatch classe-erro');
  })


  function getProductCardOriginalImages($product) {
    let originalImages = $product.data('hoverOriginalImages');

    if (originalImages && originalImages.length) return originalImages;

    originalImages = $product.find('.card-media img').map(function () {
      return {
        src: this.getAttribute('src') || this.currentSrc || '',
        srcset: this.getAttribute('srcset') || '',
        dataSrc: this.getAttribute('data-src') || '',
        dataSrcset: this.getAttribute('data-srcset') || ''
      };
    }).get();

    $product.data('hoverOriginalImages', originalImages);
    return originalImages;
  }

  function updateCardImages($product, images) {
    images.forEach((imageData, index) => {
      const $image = $product.find('.card-media img').eq(index);

      if (!$image.length || !imageData || !imageData.src) return;

      $image.attr('src', imageData.src);
      $image.attr('srcset', imageData.src);
      $image.attr('data-src', imageData.src);
      $image.attr('data-srcset', imageData.src);
    });
  }

  function restoreCardImages($product) {
    const originalImages = $product.data('hoverOriginalImages');
    if (!originalImages || !originalImages.length) return;

    originalImages.forEach((imageData, index) => {
      const $image = $product.find('.card-media img').eq(index);
      if (!$image.length) return;

      if (imageData.src) $image.attr('src', imageData.src);
      if (imageData.srcset) $image.attr('srcset', imageData.srcset);
      if (imageData.dataSrc) $image.attr('data-src', imageData.dataSrc);
      if (imageData.dataSrcset) $image.attr('data-srcset', imageData.dataSrcset);
    });
  }

  function getHoverImagesFromSwatch($swatch) {
    const title = ($swatch.attr('title') || '').trim();
    const $product = $swatch.closest('.product-item');
    const productJson = $product.data('json-product') || {};
    const newImage = $swatch.data('variant-img');
    let mediaList = [];

    if (productJson.media && title !== '') {
      mediaList = productJson.media.filter((media) => media.alt === title);
    }

    if (mediaList.length > 0) {
      return mediaList.slice(0, 2).map((media) => ({ src: media.src }));
    }

    if (newImage) {
      return [{ src: newImage }];
    }

    return [];
  }

  $(document)
    .off('mouseenter.reiseSwatchHover', '.product-item .card .swatch-label')
    .on('mouseenter.reiseSwatchHover', '.product-item .card .swatch-label', function () {
      const $swatch = $(this);
      const $product = $swatch.closest('.product-item');
      const hoverImages = getHoverImagesFromSwatch($swatch);

      getProductCardOriginalImages($product);
      if (hoverImages.length) updateCardImages($product, hoverImages);
    });

  $(document)
    .off('mouseenter.reiseCombinedHover', '.product-item .swatch-custom .item-custom--inner')
    .on('mouseenter.reiseCombinedHover', '.product-item .swatch-custom .item-custom--inner', function () {
      const $target = $(this);
      const $product = $target.closest('.product-item');
      const hoverImage = $target.attr('data-hover-image');

      if (!hoverImage) return;

      getProductCardOriginalImages($product);
      updateCardImages($product, [{ src: hoverImage }]);
    });

  $(document)
    .off('mouseleave.reiseSwatchHoverRestore', '.product-item .card-swatch, .product-item .color-swatch-grid, .product-item .swatch-custom')
    .on('mouseleave.reiseSwatchHoverRestore', '.product-item .card-swatch, .product-item .color-swatch-grid, .product-item .swatch-custom', function () {
      const $product = $(this).closest('.product-item');
      restoreCardImages($product);
    });


  function getCartSidebarAnchor() {
    return (
      document.querySelector('[data-cart-sidebar]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('.cart-count-bubble') ||
      null
    );
  }

  function removeLegacyCartToast() {
    const toast = document.getElementById('reise-cart-toast');
    if (toast) toast.remove();

    const toastStyles = document.getElementById('reise-cart-toast-styles');
    if (toastStyles) toastStyles.remove();
  }

  function openReiseSideCart() {
    removeLegacyCartToast();

    if (document.body.classList.contains('template-cart')) return;

    const sidebar = document.getElementById('halo-cart-sidebar');
    if (sidebar) {
      document.body.classList.remove('add-to-cart-show', 'cart-modal-show');
      document.body.classList.add('cart-sidebar-show');
      return;
    }

    const anchor = getCartSidebarAnchor();
    if (anchor && typeof anchor.click === 'function') {
      anchor.click();
    }
  }

  document.addEventListener('reise:added-to-cart', function () {
    openReiseSideCart();
  });

  window.__reiseHandleCartAdded = function () {
    openReiseSideCart();
  };

  if (window.__reisePendingCartAdded) {
    window.__reiseHandleCartAdded(window.__reisePendingCartAdded);
    window.__reisePendingCartAdded = null;
  }


})
